var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7018 7.68336L13.9018 4.32503C12.5935 3.40836 10.5852 3.45836 9.32682 4.43336L5.15182 7.6917C4.31849 8.3417 3.66016 9.67503 3.66016 10.725V16.475C3.66016 18.6 5.38516 20.3334 7.51016 20.3334H16.4935C18.6185 20.3334 20.3435 18.6084 20.3435 16.4834V10.8334C20.3435 9.70836 19.6185 8.32503 18.7018 7.68336ZM12.6268 17C12.6268 17.3417 12.3435 17.625 12.0018 17.625C11.6602 17.625 11.3768 17.3417 11.3768 17V14.5C11.3768 14.1584 11.6602 13.875 12.0018 13.875C12.3435 13.875 12.6268 14.1584 12.6268 14.5V17Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1f473e0af84ba2678cd5409949375cf8.svg";
export { ForwardRef as ReactComponent };